import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/BCL_nobg_crop.png';
import './Navbar.css';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: 'Home', path: '/' },
    { text: 'E-Logbook', path: '/e-logbook', external: true },
    { text: 'Careers', path: '/careers' },
    { text: 'Contact', path: '/contact' },
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            {item.external ? (
              <ListItemButton component="a" href={item.path}>
                <ListItemText primary={item.text} />
              </ListItemButton>
            ) : (
              <ListItemButton component={Link} to={item.path}>
                <ListItemText primary={item.text} />
              </ListItemButton>
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar 
        position="sticky" 
        elevation={0}
        sx={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(81, 168, 177, 0.1)',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.01)'
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', padding: '0.5rem 2rem' }}>
          <Box 
            component={Link} 
            to="/" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              textDecoration: 'none',
              cursor: 'pointer'
            }}
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <img 
                src={logo} 
                alt="BioCircuit Labs" 
                style={{ height: '50px', marginRight: '15px' }}
              />
            </motion.div>
            <Box>
              <Typography
                variant="h5"
                component="span"
                sx={{ 
                  fontFamily: 'Quicksand, sans-serif',
                  color: '#51A8B1',
                  fontWeight: 700 
                }}
              >
                BioCircuit
              </Typography>
              <Typography
                variant="h5"
                component="span"
                sx={{
                  fontFamily: 'Barlow, sans-serif',
                  color: '#A8CF45',
                  fontWeight: 700,
                  marginLeft: '8px'
                }}
              >
                LABS
              </Typography>
              <Typography
                component="div"
                sx={{
                  fontFamily: 'Barlow, sans-serif',
                  color: '#9FB0B2',
                  fontWeight: 600,
                  fontSize: '0.6rem',
                  letterSpacing: '0.18em',
                  textTransform: 'uppercase',
                  marginTop: '-2px',
                }}
              >
                AI Powered
              </Typography>
            </Box>
          </Box>

          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ color: '#51A8B1' }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {menuItems.map((item) => (
                <motion.div
                  key={item.text}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Button
                    {...(item.external
                      ? { component: 'a', href: item.path }
                      : { component: Link, to: item.path })}
                    sx={{
                      color: location.pathname === item.path ? '#A8CF45' : '#51A8B1',
                      fontFamily: 'Barlow, sans-serif',
                      fontWeight: 600,
                      fontSize: '1rem',
                      '&:hover': {
                        backgroundColor: 'rgba(168, 207, 69, 0.1)',
                      },
                    }}
                  >
                    {item.text}
                  </Button>
                </motion.div>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar;